import { Typography, styled } from '../../../../../base';

export const GroupTitle = styled(Typography)(({ theme }) => ({
    color: theme.palette.primary.main,
    fontWeight: 500,
    margin: '24px 0 16px',
}));

export const GroupWrap = styled(Typography)(({ theme }) => ({
    bgcolor: 'background.paper',
    borderRadius: 15,
    border: `1px solid ${theme.palette.divider}`,
}));
